var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.deliveryZoneDetail)?_c('delivery-zone-form',{attrs:{"deliveryZone":_vm.deliveryZoneDetail},on:{"submit":_vm.update}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }